import { BandPicker } from "../../components/BandPicker";

interface BandSearchDropdownProps {
  value: string | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  controlStyle?: React.CSSProperties;
  except?: string[];
}

const BandSearchDropdown = ({
  value,
  onChange,
  placeholder,
  controlStyle,
  except,
}: BandSearchDropdownProps) => {
  return (
    <BandPicker
      value={value}
      handleChange={(bandId) => onChange(bandId)}
      placeholder={placeholder}
      controlStyle={controlStyle}
      except={except}
    />
  );
};

export default BandSearchDropdown;
